<template>
  <div v-if="kiosksForEvent.length" data-testid="shop-kiosks-by-event">
    <h3 class="my-3 text-left text-headline-s">{{ event?.name }}</h3>
    <BookingItem v-for="kiosk in kiosksForEvent" :key="kiosk.id" :kiosk="kiosk" :event="event" :is-past="props.isPast" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import BookingItem from '@/components/FestivalShop/BookingItem.vue'
import type { EventsQuery, FestivalShopKiosksQuery } from '@/gql/myomr'

type KioskNode = FestivalShopKiosksQuery['festivalShopKiosks']['nodes'][number]

const props = defineProps<{
  event: NonNullable<EventsQuery['events']['nodes']>[number]
  isPast: boolean
  kiosks: KioskNode[]
}>()

const kiosksForEvent = computed(() => {
  const eventId = props.event?.id
  if (!eventId) return []
  return props.kiosks.filter((kiosk) => {
    if (kiosk.__typename === 'Event') return kiosk.id === eventId
    if (kiosk.__typename === 'Booth') return (kiosk as KioskNode & { event?: { id: string } }).event?.id === eventId
    return false
  })
})
</script>
